export default __webpack_public_path__ + "static/media/bear-1.4c78c660.png";